import { createAsyncThunk } from "@reduxjs/toolkit";
import * as aTypes from "./types";
import insertProcessAPI from "../../api/insertProcessAPI";
import exportAPI from "../../api/exportAPI";
import { setupErrorPayload } from "../../app/config/utils";

export const triggerInsertProcess = createAsyncThunk(
  aTypes.TRIGGER_INSERT_PROCESS,
  async (adClientId = "", thunkAPI) => {
    try {
      const res = await insertProcessAPI.triggerInsertProcess(
        thunkAPI.getState().auth.jwt,
        adClientId
      );
      console.log("TRIGGER_INSERT () => ", res);
      return res;
    } catch (error) {
      console.log("TRIGGER_INSERT_ERROR () => ", error);
      const payload = setupErrorPayload(error);
      return thunkAPI.rejectWithValue(payload);
    }
  }
);

export const triggerExportProcess = createAsyncThunk(
  aTypes.TRIGGER_EXPORT_PROCESS,
  async (adClientId = "", thunkAPI) => {
    try {
      const resp = await exportAPI.triggerExportConteos(
        thunkAPI.getState().auth.jwt,
        adClientId
      );
      return resp; // full axios response (headers + blob data)
    } catch (error) {
      console.log("TRIGGER_EXPORT_ERROR () => ", error);
      const payload = setupErrorPayload(error);
      return thunkAPI.rejectWithValue(payload);
    }
  }
);
